module.exports = __webpack_public_path__ + "images/powerups/voting/screenshots/2015-3-23-screenshot1.de063c1421497f609fef.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/powerups/voting/screenshots/2015-3-23-screenshot1.png
// module id = vZA+
// module chunks = 0